import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import _ from "lodash";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import TextAreaField from "./TextAreaField";
import { useLazyGetFormDataVariablesQuery } from "modules/pvs_activities/redux/service/formData";
import { processVariables } from "modules/pvs_activities/helper.general";
import dayjs from "dayjs";
import DatePickerCustom from "components/DatePickerCustom";

const defaultProps = {
    plain: false,
    readOnly: false,
    label: "Select",
    listID: "",
    value: "",
    data: null, // [ { id: '', value: '' } ]
    onChange: () => { },
    hasOptions: false,
    options: [],
    required: false,
    hasNA: false,
    reason: "",
    onReasonChange: () => { },
    onReasonBlur: () => { },
    useOptionLabel: false,
    processVariables: false,
    missionId: 0,
    viewVertical: false,
};

const DateFinalisation = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };

    const reportLists = useSelector((s) => s.report.lists);
    const [triggerVariables, variablesRes] = useLazyGetFormDataVariablesQuery();
    const [selectedOption, setSelectedOption] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleOnChange = (val, listElementId, e) => {
        let finalValue = val;

        if (val === "other") {
            setSelectedOption("other");
            return;
        }
        else{
            setSelectedOption("")
        }

        if (props.plain) return props.onChange(finalValue, e);
        const obj = { content: finalValue, list_id: props.listID, list_element_id: listElementId };
        props.onChange(obj, e);
    };



    const processVariablesLocal = useCallback(
        (val) => {
            if (props.processVariables && variablesRes.isSuccess) return processVariables(variablesRes, val ?? "");
            return val;
        },
        [variablesRes, props.processVariables]
    );

    const finalOptions = useMemo(() => {
        if (props.hasOptions) return props.options;
        let listObj = reportLists?.find((r) => String(r.id) === String(props.listID));
        if (![undefined, null].includes(listObj)) {
            return listObj.relationElements;
        } else {
            return [];
        }
    }, [props.hasOptions, props.options, props.listID]);
    useEffect(() => {
        if (props.processVariables && ![undefined, null, "", 0, "0"].includes(props.missionId)) {
            triggerVariables(props.missionId, true);
        }
    }, [props.missionId, props.processVariables]);
    useEffect(() => {
        if (selectedOption === "other" && startDate && endDate) {
            const formattedStart = dayjs(startDate).format("DD-MMM-YY");
            const formattedEnd = dayjs(endDate).format("DD-MMM-YY");
            const finalDate = `${formattedStart} - ${formattedEnd}`;
            props.onChange(finalDate);
        }
    }, [startDate, endDate, selectedOption]);
    return props.readOnly == 1 ? (
        props.value
    ) : (
        <FormControl component="fieldset">
            {/* <FormLabel component="legend">{props.label}</FormLabel> */}
            <RadioGroup row={props.viewVertical === false} name={_.uniqueId("element_")}>
                {finalOptions.map((r) => (
                    <FormControlLabel
                        key={r.id}
                        control={<Radio />}
                        label={props.useOptionLabel ? r.label : processVariablesLocal(r.value)}
                        value={processVariablesLocal(r.value)}
                        onChange={(e) => handleOnChange(processVariablesLocal(r.value), r.id, e)}
                        checked={selectedOption !== "other" && (
                            props.plain
                                ? String(props.value) === String(processVariablesLocal(r.value))
                                : props.value?.list_element_id === r.id
                        )}
                        disabled={props.readOnly || props.disabled}
                        required={props.required}
                    />
                ))}
                {[1, true].includes(props.hasNA) && (
                    <FormControlLabel
                        control={<Radio />}
                        label="NA"
                        value="NA"
                        onChange={(e) => handleOnChange(e.target.value, "", e)}
                        checked={props.value.content === "NA"}
                        disabled={props.readOnly || props.disabled}
                        required={props.required}
                    />
                )}
                {[1, true].includes(props.hasNA) && props.value.content === "NA" && (
                    <div>
                        <TextAreaField
                            label={"NA Reason"}
                            type={"text"}
                            value={props.value.content === "NA" ? props.reason : ""}
                            onChange={(val, e) => props.onReasonChange(val, e)}
                            onBlur={props.onReasonBlur}
                            disabled={props.readOnly}
                            error={false}
                        />
                    </div>
                )}
            </RadioGroup>
            {selectedOption === "other" && (
                <div style={{ display: "flex", gap: "10px", marginTop: "10px" }}>
                    <DatePickerCustom
                     sx={{ width: "100%" }}
                     fullWidth
                        value={startDate}
                        onChange={(date) => setStartDate(date)}
                        placeholder="Start Date"
                    />
                    <DatePickerCustom
                     sx={{ width: "100%" }}
                     fullWidth
                        value={endDate}
                        onChange={(date) => setEndDate(date)}
                        placeholder="End Date"
                        minDate={startDate}
                    />
                </div>
            )}
        </FormControl>
    );

};

export default DateFinalisation
